/* eslint-disable no-magic-numbers */

import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/lib/react';
import { theme } from '@mtsbank/ui-kit';
const initial = 20;
export interface SpacerProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Высота и минимальная ширина компонента при разрешении от 1024px
   */
  space?: number;
  /**
   * Высота и минимальная ширина компонента при разрешении менее 1024px
   */
  spacemob?: number;
  /**
   * Высота и минимальная ширина компонента при разрешении менее 768px
   */
  spacetablet?: number;
  /**
   * включает/ выключает spacemob поведение
   */
  samespace?: boolean;
}
export const Inner = /*#__PURE__*/styled("div")({
  name: "Inner",
  class: "i10tx7y0",
  vars: {
    "i10tx7y0-0": [({
      spacemob = initial
    }) => spacemob, "px"],
    "i10tx7y0-3": [({
      spacetablet = initial
    }) => spacetablet, "px"],
    "i10tx7y0-6": [({
      space = initial
    }) => space, "px"]
  }
});
export const Spacer: FC<SpacerProps> = ({
  space = initial,
  spacemob,
  spacetablet,
  // Добавляем пропс spacetablet
  samespace = false,
  ...rest
}) => <Inner data-testid="spacer" space={space} spacemob={spacemob} spacetablet={spacetablet} // Передаем пропс spacetablet
samespace={samespace} {...rest} />;

require("./Spacer.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./Spacer.tsx");